/**
 * Validates a returnto param is a relative path
 */
export const isValidReturnTo = (returnTo: string | null): returnTo is string => {
	if (returnTo) {
		const returnURL = new URL(returnTo, window.location.origin);
		return returnURL.origin === window.location.origin;
	}
	return false;
};
